<template>
  <button v-if="href == null" class="button902 border-0" data-slot="default">
    <slot>button</slot>
  </button>
  <m-a :href="href" :target="target" v-else>
    <button class="button902 border-0" data-slot="default">
      <slot>button</slot>
    </button>
  </m-a>
</template>

<script>
import {ButtonProps} from "./ButtonProps";
import mA from '../Tags/A'

export default {
  name: "Button902",
  components: {mA},
  props: {
    ...ButtonProps
  }
}
</script>

<style scoped>
.button902 {
  display: inline-block;
  background: rgba(83, 83, 83, 0.4);
  border-radius: 3px;
  padding: 2.5px 10px;
  cursor: default;
  user-select: none;
  transition: background-color 0.3s;
}

.button902:hover {
  background: rgba(83, 83, 83, 0.8);
}
</style>